import { render, staticRenderFns } from "./ranking-elements-list-item.component.vue?vue&type=template&id=1d209e56&scoped=true"
import script from "./ranking-elements-list-item.component.vue?vue&type=script&lang=ts"
export * from "./ranking-elements-list-item.component.vue?vue&type=script&lang=ts"
import style0 from "./ranking-elements-list-item.component.vue?vue&type=style&index=0&id=1d209e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d209e56",
  null
  
)

export default component.exports